webpackJsonp([25117332837641],{

/***/ 767:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":2,"edges":[{"node":{"fields":{"slug":"/kingfisher-tall-tales/"},"excerpt":"I caught a lionfish once. It fought like a lion but I’m a scrappy guy so I gave him the old one, two and ate him. Then there was the time a…","timeToRead":1,"frontmatter":{"title":"Kingfisher Tall Tales","tags":["birds","fish","ocean life","zoology"]}}},{"node":{"fields":{"slug":"/sawfish-carpentry/"},"excerpt":"Experienced carpenter seeking new contracts. Have own saw. Specialist in sawing things. Package deal with my pal Hal Hammer, pictured below…","timeToRead":2,"frontmatter":{"title":"Sawfish Carpentry","tags":["fish","ocean life","zoology"]}}}]}},"pathContext":{"tag":"ocean life"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-ocean-life-e8820f548f66acf873da.js